import { useIntl } from 'react-intl';
import { Col, Image, Row } from '@openedx/paragon';
import { messages } from '../messages';

export const DiscountFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <Col className="col-xl-12 col-lg-3 col-12">
      <Row className="row">
        <Col className="col-12 col-lg-12 col-xl-5">
          <p>{formatMessage(messages['redeem.discount.page.footer.1'])}</p>
        </Col>
        <Col className="col-12 col-md-5 col-lg-12 col-xl-3">
          <Image
            src="/images/example-certificate-verified.png"
            alt="Example Verified Certificate"
            fluid
          />
        </Col>
        <Col className="col-12 col-md-7 col-lg-12 col-xl-4">
          <h3>
            {formatMessage(messages['redeem.discount.page.footer.2.heading'])}
          </h3>
          <p>{formatMessage(messages['redeem.discount.page.footer.2.p1'])}</p>
          <p>{formatMessage(messages['redeem.discount.page.footer.2.p2'])}</p>
          <p>{formatMessage(messages['redeem.discount.page.footer.2.p3'])}</p>
        </Col>
      </Row>
    </Col>
  );
};
